import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useEffect } from "react";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface OrderStatusRequest {
    order_idx: number[];
}

export const useDeleteOrder = (successCallback?: () => void): UseMutationResult<null, Error, OrderStatusRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, OrderStatusRequest>({
        mutationFn: async ({ order_idx }: OrderStatusRequest) => {
            const response = await axios.delete(`${enum_api_uri.delete_order}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                data: { order_idx },
            });
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getOrderList"] });
            queryClient.invalidateQueries({ queryKey: ["getOrderInfo"] });
            queryClient.invalidateQueries({ queryKey: ["getOrderHistory"] });
            successCallback?.();
        },
    });
};
